import styled from 'styled-components';

export const DateDottedLine = styled.div<{ $right: number }>`
  border-left: 1px dashed var(--border-primary);
  position: absolute;
  top: 0px;
  right: ${({ $right }) => $right}px;
  width: 1px;
  height: 200px;
  z-index: 1;
`;
